/* unplugin-vue-components disabled */import { render } from "./QuestionTplView.vue?vue&type=template&id=b1f153f4&scoped=true"
import script from "./QuestionTplView.vue?vue&type=script&lang=js"
export * from "./QuestionTplView.vue?vue&type=script&lang=js"

import "./QuestionTplView.vue?vue&type=style&index=0&id=b1f153f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1f153f4"]])

export default __exports__